import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.reset.password');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-reset-password',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.reset.password/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageResetPasswordComponent implements OnInit {
    public errorMessages: any = {};
    public data: any = { new_password: '', confirm_password: '', otp: '' };
    public otpRequired = false;
    public passwordSelected = false;
    public busy = false;
    public showPassword = false;
    public showConfirmPassword = false;

    constructor(@Inject( Service) public service: Service) { }

    private async request(action: string, params: any = {}) {
        try {
            return await wiz.call(action, params, { timeout: 135000 });
        } catch (error) {
            return { code: 503, data: { message: '처리 결과를 확인하지 못했습니다. 다시 시도해주세요.', uncertain: true } };
        }
    }

    private applyState(data: any) {
        if (typeof data?.password_selected === 'boolean') this.passwordSelected = data.password_selected;
        if (typeof data?.otp_required === 'boolean') this.otpRequired = data.otp_required;
        if (this.passwordSelected) {
            this.data.new_password = this.data.confirm_password = '';
        }
    }

    private async completed(data: any) {
        this.data.new_password = this.data.confirm_password = this.data.otp = '';
        if (data.notification_sent === false) await this.service.alert.error('설정은 완료되었지만 안내 메일을 보내지 못했습니다. 관리자에게 문의해주세요.');
        if (data.otp_issuance === 'N') {
            await this.service.alert.success('비밀번호가 설정되었습니다. 새로운 OTP를 발급해주세요.');
            location.href = '/otp/issuance';
        } else {
            await this.service.alert.success('비밀번호가 설정되었습니다. 새 비밀번호와 다음 회차의 OTP로 로그인해주세요.');
            location.href = '/login';
        }
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(false, '/main');
        const response = await this.request('get_reset_context');
        if (response.code === 200) {
            this.applyState(response.data);
            if (response.data.completed) await this.completed(response.data);
        } else {
            await this.service.alert.error(response.data?.message || response.data);
            if (response.code === 401 || response.code === 403) location.href = '/login';
        }
        await this.service.render();
    }

    public validatePassword(password: string): boolean {
        return password.length <= 512 && /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>\/?~-]).{9,}$/.test(password);
    }

    public async resetPassword() {
        if (this.busy) return;
        this.errorMessages = {};
        if (!this.passwordSelected) {
            if (!this.validatePassword(this.data.new_password))
                this.errorMessages.new_password = '비밀번호는 9자리 이상, 숫자, 문자, 특수문자를 포함해야 합니다.';
            if (!this.data.confirm_password || this.data.new_password !== this.data.confirm_password)
                this.errorMessages.confirm_password = '비밀번호가 일치하지 않습니다.';
        }
        if (this.otpRequired && !/^\d{6}$/.test(this.data.otp))
            this.errorMessages.otp = '새 OTP 인증번호 6자리를 입력해주세요.';
        if (Object.keys(this.errorMessages).length) {
            await this.service.render();
            return;
        }
        const params: any = {};
        if (!this.passwordSelected) params.new_password = this.data.new_password;
        if (this.otpRequired) params.otp = this.data.otp;
        this.busy = true;
        this.service.loading.show();
        try {
            const response = await this.request('reset_password', params);
            this.data.otp = '';
            this.applyState(response.data);
            if (response.code === 200) {
                await this.completed(response.data);
                return;
            }
            // A response can be lost after either LDAP or DB completed. Restore
            // server state before inviting a retry with different input.
            if (response.data?.uncertain || response.code >= 500) {
                const state = await this.request('get_reset_context');
                if (state.code === 200) {
                    this.applyState(state.data);
                    if (state.data.completed) { await this.completed(state.data); return; }
                }
            }
            await this.service.alert.error(response.data?.message || response.data);
            if (response.code === 401 || response.code === 403) location.href = '/login';
        } finally {
            this.busy = false;
            this.service.loading.hide();
        }
    }
}

export default PageResetPasswordComponent;